import { getMyDriveWayfindingCopy } from '@/i18n/my-drive-wayfinding-copy';

/**
 * A folder segment named after a task route: interactive tasks (`ot_…`) and
 * scheduled runs (`schedule-…`). Task output folders keep these segments in
 * their paths; people see the task title instead.
 */
export function isTaskFolderRouteName(name: string): boolean {
  return name.startsWith('ot_') || name.startsWith('schedule-');
}

/**
 * The label for a folder that may be a task's output folder. The server sets
 * `displayName` to the task title only when the viewer can read the task, so
 * a task-route folder without one shows the localized "Untitled task" and
 * never its raw route id. Other folders keep their own name.
 */
export function taskAwareFolderLabel(
  args: { name: string; displayName?: string | null },
  locale: string
): string {
  const displayName = args.displayName?.trim();
  if (displayName) return displayName;
  return isTaskFolderRouteName(args.name)
    ? getMyDriveWayfindingCopy(locale).untitledTask
    : args.name;
}

/** `taskAwareFolderLabel` for the last segment of an absolute path. */
export function taskAwarePathLabel(
  path: string,
  locale: string,
  displayName?: string | null
): string {
  const name = path.split('/').filter(Boolean).at(-1) ?? path;
  return taskAwareFolderLabel({ name, displayName }, locale);
}
